import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../context/NotificationContext";
import "../styles/global.css";
import loginImg from "../assets/LogIn.png";
import { handleApiError } from "../utils/notificationHelpers";
import Button from "../components/Button";

const CreateNewPassword = () => {
  const { notify } = useNotification();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      notify.error("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      notify.error("Password must be at least 6 characters long");
      return;
    }

    // API call for creating new password will go here later
    console.log("API call to create new password would go here");
    console.log("New password:", password);
    console.log("Confirm password:", confirmPassword);

    notify.success("Password updated successfully (placeholder)");
    navigate("/login");
  };

  return (
    <div className="flex justify-center gap-10 h-screen bg-[#FEF3E7] padding-x">
      {/* Left Side - Image */}
      <div className="hidden md:flex items-center justify-center md:w-2/5 lg:w-1/2">
        <img
          src={loginImg}
          alt="Login"
          className="max-w-xs md:max-w-md object-contain"
        />
      </div>

      {/* Right Side - Create New Password Form */}
      <div className="w-full md:w-3/5 lg:w-3/5 xl:w-2/5 flex flex-col items-center justify-center xl:p-2 bg-white shadow-lg">
        <img
          src="/Logo.png"
          alt="Logo"
          className="w-16 md:w-20 lg:w-24 mx-auto mb-12 md:mb-16"
        />
        <h2 className="text-4xl md:text-3xl xl:text-4xl font-bold mb-14">
          Enter Password
        </h2>

        <form className="w-full px-6" onSubmit={handleSubmit}>
          <div className="mb-10">
            <input
              type="password"
              placeholder="Create your new password"
              className="w-full px-3 py-2.5 border border-black rounded-md focus:ring-2 focus:ring-orange-500 placeholder:text-gray-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-8">
            <input
              type="password"
              placeholder="Enter your new password"
              className="w-full px-3 py-2.5 border border-black rounded-md focus:ring-2 focus:ring-orange-500 placeholder:text-gray-500"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <Button text="Save" className="mt-2 w-full" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default CreateNewPassword;
